import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';
import events from '../../../test/events'

const initialState = [] //events


export default function appReducer(state = initialState, action) {

  switch (action.type) {

    /* add event */
    case types.ADD_EVENT: {
      return [
        ...state,
        action.payload
      ]
    }

    /* delete event */
    case types.DELETE_EVENT: {
      return [...state.filter(e => e.id != action.event.id)]
    }

    /** Edit event */
    case types.EDIT_EVENT: {
      return [...state.map(event => event.id == action.event.id ? (action.event) : ({ ...event }))]
    }

    case types.UPDATE_FULL_EVENTS: {
      return [
        ...initialState,
        ...action.payload
      ]
    }

    case types.RESET_EVENTS: {
      return [
        ...action.payload
      ]
    }

    case 'RESET_BLUEPRINT':
      return cloneDeep(initialState);

    default:
      return state;
  }
}
